// weavs 用パック: xlamv.com の application.js を移植したもの
// モジュール本体は app/javascript/weavs/ 配下に自己完結でコピーしている

import $ from 'jquery'
// jQueryプラグインのためにグローバルに設定
window.jQuery = window.$ = $

import '../weavs/lib/scrolla.js'
import Loader from '../weavs/loader.js'
import Top from '../weavs/top.js'
import Votes from '../weavs/votes.js'
import Members from '../weavs/members.js'
import HamburgerMenu from '../weavs/hamburgerMenu.js'
import modal from '../weavs/modal.js'
import popup from '../weavs/popup.js'
import slider from '../weavs/slider.js'
import scrollableLink from '../weavs/scrollableLink.js'
import CopyBtn from '../weavs/copyBtn.js'
import scrollBar from '../weavs/scrollBar.js'
import {playAudio} from '../weavs/sound.js'
import PlatinumGlanz from '../weavs/platinumGlanz.js'
import {scrollLoader} from '../weavs/scrollLoader.js'
import {parallax} from '../weavs/parallax.js'
import '../weavs/accordion.js'
import '../weavs/backButton'

class Application {
  constructor() { }

  initialize() {
    new HamburgerMenu().initialize()
    this.loader = new Loader().initialize()
    new CopyBtn().initialize()
    modal.initialize()
    popup.initialize()
    slider.initialize()
    scrollableLink.initialize()
    scrollBar.initialize()
    new Top().initialize()
    new Votes().initialize()
    new Members().initialize()
    new PlatinumGlanz().initialize()
    $('.scrolla').scrolla({
      mobile: true,
      once: true
    })
    window.addEventListener('load', () => {
      scrollLoader()
      parallax()
      const $body = $('.preload,body')
      $body.addClass('loaded')
      $body.removeClass('preload')
      this.loader.hide()

      const $soundBtn = $('.js-sound-play-btn')
      const onPlayEnd = () => {
        $soundBtn.removeClass('sound-playing')
      }
      $soundBtn.on('click', (e) => {
        const el = $(e.currentTarget)
        const soundPath = el.attr('data-sound-src')
        $soundBtn.removeClass('sound-playing')
        el.addClass('sound-playing')
        playAudio(soundPath, onPlayEnd)
      })
    })
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new Application().initialize()
})
